import React from "react";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";
import QueueAnim from "rc-queue-anim";
import TweenOne from "rc-tween-one";
import { Button } from "antd";
import bannerImageSrc from "./banner.jpg";
import { prefix } from "../../../config";
import "./index.scss";
import { AdaptionSection } from "../../../components/AdaptionSection";

const messages = {
  title: "开放 创新 融合",
  description:
    "依图致力于建设开放、创新、融合的AI生态体系，通过打造“依图+X”生态合作模式，帮助合作伙伴构建基于开放式AI视觉计算平台的成功业务实践和解决方案，共建AI多维应用场景，携手共赢未来"
};

const cls = "AppBanner";

interface IAppBannerProps {
  onClickPartner: () => void;
}

export class AppBanner extends React.PureComponent<IAppBannerProps> {
  render() {
    return (
      <div className={cls}>
        <img className={`${cls}-image`} src={bannerImageSrc} />

        <div className={`${cls}-contentWrapper`}>
          <AdaptionSection className={`${cls}-content`}>
            <div className={`${cls}-contentInner`}>
              <QueueAnim type="bottom" leaveReverse key="page" delay={[0, 100]}>
                <div className={`${cls}-title`}>{messages.title}</div>
                <div className={`${cls}-description`}>
                  {messages.description}
                </div>
              </QueueAnim>

              <TweenOne
                key="button"
                style={{ textAlign: "left" }}
                animation={{ y: 30, opacity: 0, type: "from", delay: 300 }}
              >
                <Button
                  className={`${cls}-button`}
                  onClick={this.props.onClickPartner}
                >
                  成为伙伴
                </Button>
                <Button
                  className={`${cls}-button`}
                  href={`${prefix}/searchPartner`}
                >
                  查找伙伴
                </Button>
              </TweenOne>
            </div>
          </AdaptionSection>
        </div>
      </div>
    );
  }
}
